<template>
  <div class="products px-5 py-5">
    <div class="row">
      <div class="col">
        <h1 class="fw-600 fs-24 mb-0">Editar Produto</h1>
        <h6 class="fw-400">{{ product.title }}</h6>
      </div>
    </div>
    <hr>
    <FormProducts :_product="product" @update="update" />
    <LoadingComponent :loading="loading" />
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import FormProducts from './FormProducts'
import LoadingComponent from '../../components/layout/LoadingComponent'

export default {

  name: 'ShowProductsPage',

  components: {
    LoadingComponent,
    FormProducts
  },

  data () {
    return {
      product: {}
    }
  },

  watch: {
    details () {
      this.product = {
        ...this.details
      }
    }
  },

  computed: mapState({
    details: state => state.products.details,
    loading: state => state.products.loading
  }),

  methods: {

    ...mapActions('products', [
      'show',
      'update'
    ])

  },

  mounted () {
    this.show(this.$route.params.id)
  }

}

</script>
